import {
  Primary13Regular,
  SimpleModal,
  Text
} from '@sequencehq/core-components'
import { FC } from 'react'
import { match } from 'ts-pattern'

type Props = {
  changeType: 'customer' | 'dealType' | 'effectiveFrom' | 'overwritePricing'
  onConfirm: () => Promise<boolean>
  onCancel: () => void
}

export const ConfirmAmendmentChange: FC<Props> = ({
  changeType,
  onConfirm,
  onCancel
}) => {
  const { testId, title, submitButtonText, body } = match(changeType)
    .with('customer', () => ({
      testId: 'quote.modals.confirmChangeCustomer',
      title: 'Change customer',
      submitButtonText: 'Change customer',
      body: 'Changing the customer for this quote will set the deal type to New Business. It will no longer amend the selected schedule. Pricing you have selected will be retained.'
    }))
    .with('dealType', () => ({
      testId: 'quote.modals.confirmChangeDealType',
      title: 'Change deal type',
      submitButtonText: 'Change deal type',
      body: 'Changing the deal type will no longer amend the selected schedule. Pricing you have selected will be retained.'
    }))
    .with('effectiveFrom', () => ({
      testId: 'quote.modals.confirmChangeEffectiveFrom',
      title: 'Change amendment start date',
      submitButtonText: 'Change start date',
      body: "Changing the amendment start date will reset this quote's phases to those used on the original schedule. Any changes you've made to pricing or phases will be reverted."
    }))
    .with('overwritePricing', () => ({
      testId: 'quote.modals.confirmOverwritePricing',
      title: 'Replace quote pricing',
      submitButtonText: 'Replace pricing',
      body: 'Changing this quote to use the amendment deal type will overwrite any existing phases and pricing on this quote.'
    }))
    .exhaustive()

  return (
    <SimpleModal
      variant="dialog"
      data-testid={testId}
      title={title}
      submitButtonText={submitButtonText}
      isDestructive
      disableSubmitOnEnter
      isOpen
      onClose={onCancel}
      onSubmit={onConfirm}
    >
      <Text {...Primary13Regular}>{body}</Text>
    </SimpleModal>
  )
}
